import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, CATS } from "../lib/api";
import { PhotoCard } from "../components/PhotoCard";
import { Lightbox } from "../components/Lightbox";
import { SectionHeader } from "../components/SectionHeader";

const Chip = ({ active, onClick, children, testId }) => (
  <button
    data-testid={testId}
    onClick={onClick}
    className={`rounded-full border px-4 py-2 font-mono-tech text-xs uppercase tracking-wider transition-colors duration-200 ${active ? "border-cyan-400 bg-cyan-400 text-black" : "border-white/15 text-slate-300 hover:border-cyan-400/60"}`}
  >
    {children}
  </button>
);

export default function Gallery() {
  const [params, setParams] = useSearchParams();
  const cat = params.get("cat") || "";
  const [sort, setSort] = useState("top");
  const [photos, setPhotos] = useState(null);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    setPhotos(null);
    api.get("/photos", { params: { category: cat || undefined, sort, limit: 120 } }).then((r) => setPhotos(r.data));
  }, [cat, sort]);

  return (
    <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8" data-testid="gallery-page">
      <SectionHeader kicker="// Galeria esportiva" title="Cada modalidade, um ângulo">
        <div className="flex gap-2">
          <Chip testId="gallery-sort-top" active={sort === "top"} onClick={() => setSort("top")}>Mais votadas</Chip>
          <Chip testId="gallery-sort-new" active={sort === "new"} onClick={() => setSort("new")}>Recentes</Chip>
        </div>
      </SectionHeader>
      <div className="mb-10 flex flex-wrap gap-2">
        <Chip testId="gallery-filter-all" active={!cat} onClick={() => setParams({})}>Todas</Chip>
        {CATS.map((c) => (
          <Chip key={c.slug} testId={`gallery-filter-${c.slug}`} active={cat === c.slug} onClick={() => setParams({ cat: c.slug })}>{c.name}</Chip>
        ))}
      </div>
      {photos === null ? (
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-3">{[1, 2, 3].map((i) => <div key={i} className="h-72 animate-pulse rounded-xl bg-white/5" />)}</div>
      ) : photos.length === 0 ? (
        <p data-testid="gallery-empty" className="py-20 text-center text-slate-400">Nenhuma foto nesta modalidade ainda. Seja o primeiro!</p>
      ) : (
        <div className="columns-1 gap-5 sm:columns-2 lg:columns-3">
          {photos.map((p, i) => <PhotoCard key={p.id} photo={p} index={i} rank={sort === "top" ? i + 1 : undefined} onOpen={setOpen} />)}
        </div>
      )}
      <Lightbox photo={open} onClose={() => setOpen(null)} />
    </div>
  );
}
